import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  COMPANY_INSIGHTS,
  COMPANY_INSIGHTS_DRIVER_LIST,
  COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES,
  COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES_CONFLICT_DETAILS,
} from '../../../routes/routeConstants';
import ConflictDetails from './ConflictDetails';
import ReportList from './ReportList';

const DriverHistoryConflictDetails = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver History`,
        link: `/${COMPANY_INSIGHTS}`,
      },
      {
        name: `Pacific Stereo`,
        link: `/${COMPANY_INSIGHTS_DRIVER_LIST}`,
      },
      {
        name: `Jude Nwaeze`,
        link: `/${COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES}`,
      },
      {
        name: `View Details`,
        link: `/${COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES_CONFLICT_DETAILS}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver History Conflict Details'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <ConflictDetails />
          <ReportList />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverHistoryConflictDetails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
